import { GridColDef } from '@mui/x-data-grid-premium';
import { useMemo } from 'react';
import { tableSettingsProps, useTableSettings } from 'src/core/tables/useTableSettings';
import { useTaxRates } from 'src/pages/settings/settingsRequests';

export const useTaxRatesTable = (): [columns: GridColDef[], tableSettings: tableSettingsProps] => {
  const { rows, status, loading } = useTaxRates();
  const columns: GridColDef[] = useMemo(() => [
    { field: 'Id', headerName: 'Id' },
    { field: 'Name', headerName: 'Name', flex: 1 },
    { field: 'TaxRate', headerName: 'Tax Rate' },
    { field: 'IsDefault', headerName: 'Is Default', type: 'boolean' },
    { field: 'CountriesId', headerName: 'Countries Id' },
    { field: 'Country', headerName: 'Country' },
  ], []);
  const tableSettings = useTableSettings({ tableName: 'TaxRatesTable', idPath: ['Id'], columns, rows, status });
  tableSettings.loading = loading;
  return [columns, tableSettings];
};
